import React from "react";
import { useTranslation } from "react-i18next";
import {useNavigate} from "react-router";
import "./style.scss";
import orderStore from "../../stores/order";
import { observer } from "mobx-react";
import { getCurrency } from "../../helpers/ApiHelper";

const FooterForCombinations = () => {
    const [t] = useTranslation();
    const navigate = useNavigate();

    const goBack = () => {
        navigate(-1);
    }

    return <>
        <div className="FooterSpace" />
        <div className="FooterForCombinations">
            <div className="buttons">
                <div className="button back" onClick={goBack}>{t("back")}</div>

                <div className="info">
                    <div className="text">
                        {t("itemTotal")}:
                    </div>
                    <div className="price">
                        {(orderStore.currentCombinationOrderLine?.total || 0).toFixed(2)} {getCurrency()}
                    </div>

                    <div className="text">
                        {t("orderTotal")}:
                    </div>
                    <div className="price">
                        {orderStore.order.total.toFixed(2)} {getCurrency()}
                    </div>
                </div>
            </div>
        </div>
    </>
}

export default observer(FooterForCombinations);
